import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import "../submit-datasets/actionTable.css";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ErrorDialog(props) {
  let { onClose, errors, errorGroups } = props;
  const vertical = "top";
  const horizontal = "center";

  const handleClose = (value) => {
    onClose(value);
  };

  // if (errorGroups !== "" && errorGroups !== undefined) {
  //   errors += 1;
  // }

  
  if (errors !== undefined && errors !== 0) {

    let errorMessage = errors
    if (Number.isInteger(errors)) {
      errorMessage = `${errors} Error(s) found in your submission. Please check the table below for details.`
    }

    return (
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={errors.length !== 0}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    );
  }
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={errors === 0}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity="success">
        No Errors Found. Ready to Submit
      </Alert>
    </Snackbar>
  );
}

export default ErrorDialog;
